import React, { useState } from 'react'
import {createColumnHelper,flexRender,getCoreRowModel, useReactTable} from '@tanstack/react-table'
import {useNavigate} from 'react-router-dom'
const TableListing = ({table,className,  getfilter ,rowClick,parentLink,keyValue,excludes=[],isLink}) => {

    const [filter, setFilter] = useState({
        sortBy: '',
        sortKey: ''
    })

    const navigate = useNavigate()
  return (
   <>
   <div className={`return-table-body ${className}`}>
    {/* <div>
        <span className='d-block mb-3'>Columns Selection</span>
        <ul className='d-flex align-items-center flex-wrap mb-4'>
            {table.getAllLeafColumns().map(column => {
            return (
                <li key={column.id} className='d-flex align-items-center'>
                    <input id={column.id}
                    {...{
                        type: 'checkbox',
                        checked: column.getIsVisible(),
                        onChange: column.getToggleVisibilityHandler(),
                    }}
                    />{' '}
                    <label  className='px-3 cursor-pointer' for={column.id}>
                        {column.id}
                    </label>
                </li>
            )
            })}
        </ul>
    </div> */}
        <table className='table'>
            <thead>
            {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                                <th
                                    key={header.id}

                                    onClick={() => {
                                        if (header.id) {
                                            setFilter((pre) => {
                                                if (
                                                    pre.sortKey ===
                                                    header.id
                                                ) {
                                                    return {
                                                        ...pre,
                                                        sortBy:
                                                            pre.sortBy === 1
                                                                ? -1
                                                                : 1
                                                    }
                                                }
                                                return {
                                                    ...pre,
                                                    sortKey: header.id,
                                                    sortBy: 1
                                                }
                                            })
                                            if (
                                                typeof getfilter ===
                                                'function'
                                            ) {
                                                getfilter(
                                                    filter.sortKey ===
                                                        header.id
                                                        ? {
                                                              ...filter,
                                                              sortBy:
                                                                  filter.sortBy ===
                                                                  1
                                                                      ? -1
                                                                      : 1
                                                          }
                                                        : {
                                                              ...filter,
                                                              sortKey:
                                                                  header.id,
                                                              sortBy: 1
                                                          }
                                                )
                                            }
                                        
                                    }}}

                                    colSpan={header.colSpan}
                                    className={`${
                                        header?.column?.id ===
                                        'thoughtDescription'
                                            ? 'active'
                                            : ''
                                    }`}
                                >
                                    {header.isPlaceholder ? null : (
                                        <div
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )} {" "}
                                            {/* {{
                                                asc: <>&uarr;</>,
                                                desc: <>&darr;</>
                                            }[header.column.getIsSorted()] ??
                                                null} */}

                                            <span>
                                            {filter.sortBy !== '' &&
                                            filter.sortKey !== '' &&
                                            filter.sortKey === header.id ? (
                                                filter.sortBy === 1 ? (
                                                    <>&uarr;</>
                                                ) : (
                                                    <>&darr;</>
                                                )
                                            ) : (
                                                ''
                                            )}
                                        </span>
                                        </div>
                                    )}
                                </th>
                            ))}
                        </tr>
                    ))}
            </thead>
            <tbody>
            {table.getRowModel().rows.map((row) => {
                        return (
                            <tr key={row.id}>
                                {row.getVisibleCells().map((cell) => {
                                    return (
                                        <td 
                                        style={{ cursor:"pointer"}}
                                          onClick={() => {           
                                        if(isLink && !excludes.includes(cell?.column?.id))
                                           {
                                               navigate(
                                                      `${parentLink}/${row?.original?.[keyValue]}`
                                               )
                                           }
                                            }
                                     }
                                            key={cell.id}
                                            
                                            className={`${
                                                row?.original?.id===
                                                'id'}
                                                    ? 'active'
                                                    : ''
                                            `}
                                        >
                                            {flexRender(
                                                cell.column.columnDef.cell,
                                                cell.getContext()
                                            )}
                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}
            </tbody>
        </table>
   </div>
         
   </>
  )
}

export default TableListing
